<!--
 * @Author: guozhenqiang 15138913894@163.com
 * @Date: 2023-04-23 10:16:23
 * @LastEditors: guozhenqiang 15138913894@163.com
 * @LastEditTime: 2023-05-11 14:10:21
 * @FilePath: \baichuan-website\src\components\english\home.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="home">
    <!-- 头图 -->
    <div class="title_banner">
      <el-carousel :interval="5000" height="400px" arrow="never">
        <el-carousel-item v-for="(item,index) in imgDatas" :key="index">

          <div class="banner_box_new">
            <img loading="lazy" class="bg_img" :src="item.image" />
            <div class="home_banner">
            <div class="banner_content_new">
              <div class="banner_title">{{ item.smallTitle }}</div>
              <div class="banner_desc">
                <p v-for="i in item.description.split('/n')" :key="i">
                  {{ i }}
                </p>
              </div>
            </div>
          </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 解决方案 -->
    <div class="content_box">
      <div class="content">
          <div class="solution">
              <p class="content_title">Solution</p>
              <div class="solution_details">
                  <div
                    v-for="(item,index) in solutionData"
                    :key="item.name"
                    :class="['solution_item', {bg_border: index === seleced}]"
                    :style="{width:index ===2 ? '300px' :'224px',height:index ===2 ? '160px' :'136px'}"
                    @click="solutionClick(index,item.path)"
                    >
                        <img loading="lazy" :src="item.icon" alt="">
                        <span >{{ item.name }}</span>
                  </div>
              </div>
          </div>
      </div>
      <div class="introduce">
        <p>Company introduction</p>
        <div class="introduce_c">
          <div class="introduce_c_left">
            <div class="introduce_c_left_t">Henan BCCY Environmental Energy  Co.,Ltd.</div>
            <div class="introduce_c_d" v-html="detail"></div>
            <div class="more" @click="$router.push('/english/about/0')">Learn more</div>
          </div>
          <div class="introduce_c_right">
            <video preload="none" class="video" poster="@/assets/solution/fm.png" controls width="100%" height="100%">
              <source :src="videoUrl" type="">
            </video>
          </div>
        </div>
      </div>
  </div>
  </div>
</template>
<script>
import { getEnglishCompanyDetail } from "@/request/api";
import { getBannerImgEnglish,getKLine } from "@/request/apiv2";
import ZQFD from "@/assets/home/zqfd@2x.png";
import YDCN from "@/assets/home/ydcn@2x.png";
import TPF from "@/assets/home/tpf@2x.png";
import GFCZ from "@/assets/home/gfcz@2x.png";
import SDFW from "@/assets/home/sdfw@2x.png";
import {COMMONDATA} from '@/utils/commonData'
import initMOption from '@/utils/k-line';
export default {
  components: {},
  data() {
    return {
      solutionData: [
        {
          name: "Biogas power generation",
          icon: ZQFD,
          path:'/english/solution/0'
        },
        {
          name: "Mobile heating",
          icon:YDCN,
          path:'/english/solution/1',
        },
        {
          name: "Carbon emission reduction project development and trading",
          icon:TPF,
          path:'/english/solution/2',
        },
        {
          name: "Solid waste disposal",
          icon:GFCZ,
          path:'/english/solution/3',
        },
        {
          name: "Electricity sale service",
          icon:SDFW,
          path:'/english/solution/4',
        },
      ],
      seleced: undefined,
      imgDatas:[],
      newsIndex: 0,
      newsList: [],
      newsLength: 0,
      newsObj1: {},
      newsObj2: {},
      newsObj3: {},
      newsObj4: {},
      newsObj5: {},
      detail: "",
      img: ZQFD,
      kDataDetails: {},
      videoUrl:COMMONDATA.envideoUrl
    };
  },
  created() {
    // 简介、愿景
    getEnglishCompanyDetail({
      pageType: 21
    }).then(res => {
      if (res.code === 200) {
        this.detail = res.data.pageRichContent;
      }
    });
    this.getBanner();
  },
  mounted() {
    this.initChart();
    this.getKdata();
  },
  methods: {
    //banner图片
    getBanner() {
      getBannerImgEnglish().then(res => {
        if (res.code === 200) {
          this.imgDatas = res.data;
        }
      });
    },
   async getKdata() {
     const res = await getKLine();
     return res.data;
    },
  async initChart() {
      let myChart = this.$echarts.init(document.getElementById("line_echarts"));
    const res = await this.getKdata();
    const { picupdata = [], open = "", close = "", now = "" } = res;

    let data1 = [];
    picupdata.forEach(item => {
      data1.push([...item.slice(0, 3),...item.slice(6)]);
    })
    this.kDataDetails = { open, close, now };
      const picData = {
        'data': data1,
        yestclose:close
      }
      myChart.setOption(initMOption(picData, "hs"));
    },

    // 解决方案切换
    solutionClick(i,path) {
      this.seleced = i;
      this.$router.push({
        path
      });
    },
    handleNewsTab(index) {
      this.newsIndex = index;
    },
  }
};
</script>
<style scoped>
.home {
  width: 100%;
  margin: auto;
  background-color: #f6f7fb;
  /* min-height: 1000px; */
}
.title_banner{
  width: 100%;
  margin-top: 80px;
}
@media screen and (max-width:1200px) {
  .title_banner {
    width: 1200px;
  }
}
.banner_box_new {
  width: 100%;
  height: 400px;
  object-fit: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}
.bg_img {
  width: 100%;
  height: 100%;
}
.home_banner{
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.banner_content_new {
  width: 1200px;
  margin:  104px auto;
  z-index: 2;
  color: #333;

  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: justify;
}
.banner_title {
  font-size: 36px;
}
.banner_desc {
  font-size: 14px;
  line-height: 24px;
  margin-top: 29px;
}
.content_box{
  width: 100%;
  /* padding-bottom: 159px; */
  background-color: #fff;
}
.content{
  width: 1200px;
  margin: 0 auto;

}
.solution{
  width: 100%;
}
.content_title{
 font-size: 36px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: right;
  color: #333333;
  text-align: center;
  padding: 79px 0 40px;
}
.solution_details{
  display: flex;
  justify-content: space-between;
  align-content: center;
}
.solution_item{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  cursor: pointer;
  /* width: 224px; */
  /* height: 500px; */
  /* height: 136px; */
  color: #333333;
}
.solution_item:hover{
  background: #fbfcfe;
  border-radius: 2px;
  box-shadow: 0px 4px 14px 0px rgba(0,169,186,0.20);
  color: #00A9BA;
}
.solution_item img{
  width: 48px;
  height: 48px;
  margin: 0 auto;
}
.solution_item span{
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  /* color: #333333; */
  margin-top: 8px;
  text-align: center
}
/* .solution_item span:hover{
  color: #00A9BA;
} */
.bg_border{
  /* width: 224px;
height: 136px; */
background: #fbfcfe;
border-radius: 2px;
box-shadow: 0px 4px 14px 0px rgba(0,169,186,0.20);

}

.news_investor{
  width: 100%;
  display: flex;
  margin-top: 120px;

}
.news{
  /* flex: 1widt */
  width: 600px;
}
.news_title{
  display: flex;
  align-items: center;
}
.news_title p{
  font-size: 36px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: right;
  color: #333333;
}
.news_title span{
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: justify;
  color: #00a9ba;
  margin-left: 20px;
  cursor: pointer;
}
.news_content{
  margin-top: 50px;
  height: 356px;
}
.news1{
  display: flex;
  height: 148px;
  padding-bottom: 37px;
}
.news_border{
  /* margin: 37px 0; */
  /* height: 2px; */
  /* opacity: 0.14; */
  border-bottom: 1px solid #ddd;
}
.news_second{
  margin-top: 37px;
}

.news1 img{
  width: 230px;
  height: 148px;
}
.news_details{
  width: 320px;
  height: 160px;
  overflow: hidden;
  margin-left: 30px;
}
.news_details_t{
  width: 320px;
  height: 20px;
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  color: #000000;
  overflow: hidden;
  text-overflow: ellipsis;

}
.news_details .font_style{
  width: 100%;
  height: 60px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: justify;
  color: #5b606d;
  margin-top: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 3;
  -webkit-line-clamp: 3;
}
.date{
  font-size: 12px;
font-family: PingFangSC, PingFangSC-Regular;
font-weight: 400;
text-align: left;
color: #5b606d;
margin-top: 11px;
}
.look_details{
  font-size: 12px;
font-family: PingFangSC, PingFangSC-Medium;
font-weight: 500;
text-align: justify;
color: #00a9ba;
margin-top: 17px;
cursor: pointer;
}
.investor{
  flex: 1;
  margin-left: 79px;
}
.code{
  font-size: 18px;
font-family: PingFangSC, PingFangSC-Medium;
font-weight: 500;
text-align: justify;
color: #333333;
margin-top: 46px;
}
.code_details{
  width: 100%;
  height: 38px;
  display: flex;
   justify-content: space-around;
align-items: center;
background: #f3f4f6;
border-radius: 2px;
}
.code_details{
  font-size: 14px;
font-family: PingFangSC, PingFangSC-Medium;
font-weight: 500;
text-align: justify;
color: #5b606d;
margin-top: 24px;
}
#line_echarts{
  margin-top: 30px;
  width: 100%;
  height: 220px;
}
.introduce{
  width: 100%;
  height: 680px;
  background: #fbfbfb;
  margin-top: 110px;
}
.introduce p{
  font-size: 36px;
font-family: PingFangSC, PingFangSC-Medium;
font-weight: 500;
text-align: right;
color: #333333;
text-align: center;
padding: 80px 0 50px;
}
.introduce_c{
  width: 1200px;
  margin: 0 auto;
  display: flex;
}
.introduce_c_left{
  /* width: 500px; */
  flex: 1;
  margin-right: 44px;
}
.introduce_c_left_t {
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: justify;
  color: #333333;
}
.introduce_c_d{
  margin-top: 28px;
  width: 500px;
  height: 200px;
  overflow: hidden;
  text-overflow:ellipsis;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: justify;
  color: #5b606d;
}
.more{
  width: 98px;
  height: 34px;
  text-align: center;
  line-height: 34px;
  background: #01b4bb;
  border-radius: 2px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  color: #ffffff;
  margin-top: 33px;
cursor: pointer;
}
.introduce_c_right{
  width: 656px;
  height: 341px;
}
.video{
  /* width: 656px;
  height: 341px; */
  object-fit: fill;
}
 /* 指示器激活按钮 */
/* /deep/ .is-active .el-carousel__button {
    background: #00A9BA;
    height: 4px;
} */
</style>



// WEBPACK FOOTER //
// src/components/english/home.vue